export type BaseMetadataField = 'baseRefImages' | 'baseImageUrls' | 'selectedBaseImageUrl';

export interface BaseMetadataSource {
  name: string;
  state?: string;
  baseRefImages?: string[];
  baseImageUrls?: string[];
  selectedBaseImageUrl?: string;
}

export interface ResolvedBaseMetadata {
  baseRefImages: string[];
  baseImageUrls: string[];
  selectedBaseImageUrl: string;
  conflictFields: BaseMetadataField[];
}

const MAX_BASE_IMAGE_URLS = 30;

export function normalizeAssetName(name: string): string {
  return name.trim().toLowerCase();
}

function equalStrings(left: string[], right: string[]): boolean {
  return left.length === right.length && left.every((value, index) => value === right[index]);
}

export function resolveBaseMetadata<T extends BaseMetadataSource>(sources: T[]): ResolvedBaseMetadata {
  let baseRefImages: string[] = [];
  let baseImageUrls: string[] = [];
  let selectedBaseImageUrl = '';
  let refConflict = false;
  let imageConflict = false;
  let imageOverLimit = false;
  let selectedConflict = false;

  for (const source of sources) {
    if (source.baseRefImages && source.baseRefImages.length > 0) {
      if (baseRefImages.length === 0) baseRefImages = [...source.baseRefImages];
      else if (!equalStrings(baseRefImages, source.baseRefImages)) refConflict = true;
    }

    if (source.baseImageUrls && source.baseImageUrls.length > 0) {
      if (baseImageUrls.length === 0) baseImageUrls = [...source.baseImageUrls];
      else if (!equalStrings(baseImageUrls, source.baseImageUrls)) imageConflict = true;
      if (source.baseImageUrls.length > MAX_BASE_IMAGE_URLS) imageOverLimit = true;
    }

    const selected = source.selectedBaseImageUrl?.trim() ?? '';
    if (selected !== '') {
      if (selectedBaseImageUrl === '') selectedBaseImageUrl = selected;
      else if (selectedBaseImageUrl !== selected) selectedConflict = true;
    }
  }

  const conflictFields: BaseMetadataField[] = [];
  if (refConflict) conflictFields.push('baseRefImages');
  if (imageConflict || imageOverLimit) conflictFields.push('baseImageUrls');
  if (selectedConflict) conflictFields.push('selectedBaseImageUrl');

  return {
    baseRefImages,
    baseImageUrls,
    selectedBaseImageUrl,
    conflictFields,
  };
}
